module.exports = __webpack_public_path__ + "static/media/logo.adfb7068.svg";